// src/components/operationCenter/widgets/token/derivatives/TwOiChartWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import TokenOpenInterestChart from "@/components/tokenPage/derivatives/TokenOpenInterestChart";

const TwOiChartWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  const tokenId = config.tokenId || config.ticker.toLowerCase();
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["derivatives"]}>
        <TokenOpenInterestChart tokenId={tokenId} externalRangeDays={365} />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwOiChartWidget;
